export { TrainingTips } from './TrainingTips';
